import React, { useCallback, useContext, useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';

import { GlobalContext } from '../../../../../store';
import { IEventEnrollment } from '../../../../../store/admin/eventEnrollments/store';
import { IAdminFlight } from '../../../../../store/admin/eventFlights/store';
import { ITeam } from '../../../../../store/admin/eventTeams/store';

import { sortBy } from '../../../../../contrib/sortBy';
import {
  getObjectByIdFromArray,
  IObjectById
} from '../../../../../contrib/Utils/getObjectByIdFromArray';
import { useTeamsCreatorDispatch, useTeamsCreatorState } from '../Context/TeamsCreator.context';
import { AddNewTeamCard } from './AddNewTeamCard';
import { enrollmentIncludesSeachValue } from '../Utils/enrollmentIncludesSeachValue';
import { TeamCard } from '../../../../../components/TeamCard/TeamCard';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';

interface ITeams {
  searchValue: string;
}

export const Teams = (props: ITeams) => {
  const { searchValue } = props;

  const { adminEventEnrollments, adminEventTeams, adminEvents } = useContext(GlobalContext);

  const { eventId } = useRouteInfoState();

  const { dispatch } = useTeamsCreatorDispatch();
  const { enrollments } = useTeamsCreatorState();

  const event = adminEvents.current;

  useEffect(() => {
    if (eventId && adminEventEnrollments && adminEventEnrollments[Number(eventId)]) {
      const value: IObjectById<IEventEnrollment> = getObjectByIdFromArray<IEventEnrollment>(
        adminEventEnrollments[Number(eventId)]
      );

      dispatch({
        type: 'setEnrollments',
        value
      });
    }
  }, [adminEventEnrollments[Number(eventId)]]);

  useEffect(() => {
    if (event) {
      const value = getObjectByIdFromArray<IAdminFlight>(event.flights);

      dispatch({
        type: 'setEventFlights',
        value
      });
    }
  }, [event]);

  const [teams, setTeams] = useState<ITeam[]>([]);

  const filterTeams = useCallback(
    (nonFilteredTeams: ITeam[]) =>
      enrollments
        ? nonFilteredTeams.filter(
            team =>
              (team.enrollments.length === 0 && !searchValue) ||
              team.enrollments.reduce((acc: boolean, enrollmentId: number) => {
                const enrollment = enrollments[enrollmentId];

                return (
                  acc || (!!enrollment && enrollmentIncludesSeachValue(enrollment, searchValue))
                );
              }, false)
          )
        : nonFilteredTeams,
    [adminEventTeams, enrollments, searchValue]
  );

  useEffect(() => {
    if (adminEventTeams[Number(eventId)]) {
      const filteredTeams = filterTeams(adminEventTeams[Number(eventId)]);
      const sortedTeams = sortBy(filteredTeams, 'asc', 'order');

      setTeams(sortedTeams);
    }
  }, [adminEventTeams, enrollments, searchValue]);

  return (
    <div className="teams-list">
      <Grid container={true} spacing={2}>
        {teams.map(team => (
          <Grid item={true} xs={12} sm={6} key={team.id}>
            <TeamCard context="teams" team={team} />
          </Grid>
        ))}

        <Grid item={true} xs={12} sm={6}>
          <AddNewTeamCard />
        </Grid>
      </Grid>
    </div>
  );
};
